import { Requirement } from "./requirement";

export class OotsRequest {
    uuid: string;
    userIdentifier: string
    procedureCode: string;
    dir3Code: string;
    siaCode: string;
    inSession: boolean;
    requirements: Requirement[];
}
